<script>
  import Main from "$components/common/Main.svelte";
  import About from "$components/common/About.svelte";
  import Question from "$components/common/Question.svelte";
</script>

<div
  class="pt-[72px] bg-[linear-gradient(117deg,#FF8087_0%,#D37AFF_50%,#75FFFA_100%)] max-mobile:pt-[56px]"
>
  <Main />
</div>
<About />
<Question />
